import { useCallback, useEffect } from 'react';

import useUppy from '@lyearn/shared/hooks/useUppy/useUppy';
import { getFileCategory } from '@/features/media/utils';
import { CreateMediaInput, MediaKindEnum } from '@/types/schema';

const useMediaUpload = (
  referenceId: string,
  onChange: (media?: CreateMediaInput) => void,
  media?: CreateMediaInput,
) => {
  const { files, uppy, isUploading, clearAll } = useUppy({
    referenceId,
  });

  useEffect(() => {
    if (isUploading || Object.values(files).length === 0) {
      return;
    }

    const uploadedItem = Object.values(files)?.[0];

    if (uploadedItem?.url && media?.mediaId !== uploadedItem?.id) {
      onChange({
        kind: getFileCategory(uploadedItem.meta.type!) as unknown as MediaKindEnum,
        url: uploadedItem.url,
        name: uploadedItem.meta.name,
        mimeType: uploadedItem.meta.type,
      });
      clearAll();
    }
  }, [clearAll, files, isUploading, media?.mediaId, onChange]);

  const onRemoveMedia = useCallback(
    (e: any) => {
      e.stopPropagation();
      onChange();
    },
    [onChange],
  );

  return { uppy, onRemoveMedia };
};

export default useMediaUpload;
